import React, { useState, useEffect } from 'react';
import { bool, string, object } from 'prop-types';
import { connect } from 'react-redux';
import {
    MachineTranslationButton,
    setStickyTranslationCookie,
    getStickyTranslationCookie
} from '@fiverr-private/machine_translation';
import { fetchUGC, toggleUGCView, ugcUpdated } from '../../actions/ugc';
import { MP_STICKY_EXPERIENCE } from '../../utils/mixPanelEvents';
import { BQ_STICKY_EXPERIENCE } from '../../utils/bigQueryEvents';
import { buildSourceInfo } from '../../utils/ugc/buildSourceInfo';
import SafePureComponentWrapper from '../shared/SafePureComponent';

const UGCTranslateButton = ({
    showOriginal,
    ugcMap,
    fetchUGC,
    toggleUGCView,
    ugcUpdated,
    isLeanStyle = false,
    componentName,
    useStickyTranslation = false
}, { general, biEvents }) => {
    const { gigId } = general;

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async() => {
            await stickyTranslate();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const sourceInfo = buildSourceInfo({ componentName, gigId });

    const toggleUgc = async() => {
        const shouldFetchTranslation = showOriginal && !ugcMap.translated;

        setStickyTranslationCookie(showOriginal);

        if (!shouldFetchTranslation) {
            toggleUGCView();
            return;
        }

        setLoading(true);
        await fetchUGC({ sourceInfo, shouldToggle: true });
        setLoading(false);
    };

    const onToggle = async() => {
        await toggleUgc();
        ugcUpdated();
    };

    const stickyTranslate = async() => {
        const startTime = performance.now();

        if (isStickyTranslationEnabled()) {
            await toggleUgc();
            const translationTime = performance.now() - startTime;
            reportStickyTranslation(translationTime);
        }
    };

    const reportStickyTranslation = (translationTime) => {
        biEvents.sendMixPanelEvent({ eventName: MP_STICKY_EXPERIENCE });
        biEvents.sendBigQueryEvent({
            eventName: BQ_STICKY_EXPERIENCE,
            params: {
                stickyTranslationResponseTime: translationTime
            }
        });
    };

    const isStickyTranslationEnabled = () => {
        const stickyTranslationCookie = getStickyTranslationCookie();

        return useStickyTranslation && stickyTranslationCookie;
    };

    const { LEAN_DEFAULT, DEFAULT } = MachineTranslationButton.STYLES;
    const style = isLeanStyle ? LEAN_DEFAULT : DEFAULT;

    return (
        <section className="ugc-translation-button-wrapper">
            <MachineTranslationButton loading={loading}
                toggled={!showOriginal}
                onClick={onToggle}
                style={style}
                sourceInfo={sourceInfo}/>
        </section>
    );
};

UGCTranslateButton.propTypes = {
    showOriginal: bool,
    isLeanStyle: bool,
    componentName: string
};

UGCTranslateButton.contextTypes = {
    general: object,
    biEvents: object
};

const mapStateToProps = ({ ugc }) => ({
    ...ugc
});

const ConnectedUGCTranslateButton = connect(mapStateToProps, {
    fetchUGC,
    toggleUGCView,
    ugcUpdated
})(UGCTranslateButton);

export { ConnectedUGCTranslateButton };

export default SafePureComponentWrapper(ConnectedUGCTranslateButton);
